/**
 * @module ShowMoreOrLessValidationFactory
 * @date 03/08/2017
 * @copyright 2017 Empower Retirement
 * @description
 *
 *      Validates the threshold requests. Will throw an error if more than threshold for truncation was requested.
 *
 */

import _ from "lodash";

/**
 * The constructor's parameters are "injected" via AJS's IoC.
 *
 * @constructor
 */
var ShowMoreOrLessValidationFactory = function () {
    /**
     * Error message hash.
     * @type {{INVALID_THRESHOLD_CONFIG: string}}
     */
    var ERROR = {
        INVALID_THRESHOLD_CONFIG:
            "You must specify one, and only one, type of threshold (chars or words)",
        INVALID_THRESHOLD_NUMBER_EXPECTED: "You must specify a valid number for the threshold"
    };

    //-----------------------------------------------------------------------
    // PROTECTED METHODS
    //-----------------------------------------------------------------------

    /**
     * Determines if one and only one threshold for truncation was requested.
     *
     * @throws {Error}
     */
    var failIfWrongThresholdConfig = function (firstThreshold, secondThreshold) {
        if ((!firstThreshold && !secondThreshold) || (firstThreshold && secondThreshold)) {
            throw ERROR.INVALID_THRESHOLD_CONFIG;
        } else if (!_.isNumber(firstThreshold) && !_.isNumber(secondThreshold)) {
            throw ERROR.INVALID_THRESHOLD_NUMBER_EXPECTED;
        }
    };

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    return {
        failIfWrongThresholdConfig: failIfWrongThresholdConfig,
        ERROR: ERROR
    };
};

ShowMoreOrLessValidationFactory.$inject = [];
export default ShowMoreOrLessValidationFactory;
